import getIdReduxUtil from 'modules/redux/utils/get-id'
import { toSlugStringUtil } from 'packages/src'
import getNameReduxUtil from 'modules/redux/utils/get-name'

export default function getPathnamePlanUtil (instance) {
  const name = getNameReduxUtil(instance)
  return `/plans/${getIdReduxUtil(instance)}/${toSlugStringUtil(name)}`
}
